/** Side of a stored workspace avatar, in pixels: sharp at 64px on a 2× screen, a few kilobytes as a data URL. */
const AVATAR_SIZE = 128;

/**
 * Crops an image file to a centered square and encodes it small enough to store
 * inline on the workspace. Throws when the browser cannot decode the file.
 */
export async function avatarDataUrl(file: File): Promise<string> {
  const bitmap = await createImageBitmap(file);
  try {
    const side = Math.min(bitmap.width, bitmap.height);
    const canvas = document.createElement("canvas");
    canvas.width = AVATAR_SIZE;
    canvas.height = AVATAR_SIZE;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("canvas unavailable");
    ctx.imageSmoothingQuality = "high";
    ctx.drawImage(bitmap, (bitmap.width - side) / 2, (bitmap.height - side) / 2, side, side, 0, 0, AVATAR_SIZE, AVATAR_SIZE);
    // WebP where the browser can encode it; a browser that cannot falls back to PNG by itself.
    return canvas.toDataURL("image/webp", 0.9);
  } finally {
    bitmap.close();
  }
}
